import React, { useState, useEffect } from "react";
import { normalizeComponentTree } from "../../shared/Filter";

function Copyable({
  children,
  copy,
}: {
  children: string | JSX.Element;
  copy?: string | JSX.Element;
}) {
  const [confirmation, setConfirmation] = useState<string | null>(null);
  const [confirmationStyle, setConfirmationStyle] = useState({
    opacity: 1,
    transition: "opacity .25s ease",
  });

  useEffect(() => {
    if (confirmation) {
      setConfirmationStyle((x) => ({ ...x, opacity: 1 }));

      const timeout = setTimeout(() => {
        setConfirmationStyle((x) => ({ ...x, opacity: 0 }));

        setTimeout(() => {
          setConfirmation(null);
        }, 250);
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [confirmation]);

  return (
    <>
      {children}
      <span className="Copyable-button-wrapper">
        {" "}
        <button
          onClick={() => {
            navigator.clipboard.writeText(
              normalizeComponentTree(copy || children)
            );
            setConfirmation("Link copied to clipboard!");
          }}
        >
          Copy
        </button>{" "}
        {confirmation ? (
          <span className="Copyable-confirmation" style={confirmationStyle}>
            {confirmation}
          </span>
        ) : null}
      </span>
    </>
  );
}

export default Copyable;
